import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LclShipmentService {
  public updateLclShipment$: Subject<boolean> = new Subject<boolean>();
}
